import { gql } from '@apollo/client';

export const GET_TEST_REPORT = gql`
  query GetTestReport($where: JSON) {
    backflowTests(where: $where) {
      jobId
      waterSupplier {
        profileId
        rpCheck2Type
      }
      waterSupplierStatus
      testingCompanyName
      testerName
      dateTested
      finalResult
      #     flags
      job {
        id
        address {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        formData
        attachments {
          id
          contentType
          url
          thumb(size: 500)
          profile {
            id
            name
          }
          created
        }
        siteContact {
          name
          address {
            id
            street1
            street2
            city
            state
            zip
            zipExt
          }
          email
          phone
        }
        comments {
          id
          type
          comment
          profile {
            id
            name
          }
          created
        }
        statusChanges {
          id
          fromStatus
          toStatus
          profile {
            id
            name
          }
          created
        }
        #       submitted
        #       customer
        #       testing company
        #       tester
      }
      originalBackflowAssembly {
        id
        modelId
        model {
          id
          name
          backflowAssemblyMake {
            name
          }
        }
        serialNumber
        size
        type
        location
      }
      backflowAssembly {
        id
        modelId
        model {
          id
          name
          backflowAssemblyMake {
            name
          }
        }
        serialNumber
        size
        type
        location
        waterService {
          id
          siteNumber
          meterNumber
          serviceAddresses(where: { active: true }, limit: null) {
            customer(where: { status: 1 }) {
              id
              profile {
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const APPROVE_BACKLOW_TEST = gql`
  mutation ApproveBackflowTest($jobId: ID!) {
    approveBackflowTest(jobId: $jobId) {
      jobId
      waterSupplierStatus
    }
  }
`;
